(function () {
  'use strict';

  angular.module('web2print', [
    'ngMaterial',
    'ngAria',
    'ngMessages',
    'ngAnimate',
    'ngSanitize',
    'ngResource',
    'ui.router',
    'tmh.dynamicLocale',
    'pascalprecht.translate',
    'ngStorage',
    'ui.mask',
    'ui.select',
    'ui.bootstrap',
    'cwill747.phonenumber',
    'ngFileUpload',
    'ngWebSocket',

    'web2print.landing',
    'web2print.recipients',
    'web2print.whereTo',
    'web2print.newAddress',
    'web2print.orders',
    'web2print.message',
    'web2print.shared',
    'web2print.payment',
    'web2print.sidebar',
    'web2print.receipt',
    'web2print.odrCounter',
    'rzModule',
    'angularMoment'
  ])
    .value('appOptions', {
      country: 'SE'
    });
})();
